import axios from "axios";
const authHeaders = () => ({
    accessToken: localStorage.getItem('accessToken')
});

export const fetchPipelineOrders = async (params = {}) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/pipeline`,
        {
            params,
            headers: authHeaders()
        }
    );
    return response.data;
};

export const updatePipelineStage = async (orderId, payload = {}) => {
    const body = typeof payload === "string" ? { soStatus: payload } : payload;
    const response = await axios.patch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/pipeline-stage`,
        body,
        {
            headers: authHeaders()
        }
    );
    return response.data;
};

export const updateProductsToOrder = async (orderId,payload) => {
    try {
        const response=await axios.put(
            `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/edit/${orderId}`,
            payload,
            {
                headers: {
                    accessToken: localStorage.getItem('accessToken')
                }
            }
        );
        return response.data
    } catch (error) {
        if (process.env.NODE_ENV === "development") {
            console.error("Order product update failed:", error?.response?.data || error);
        }
        throw error;
    }
}

export const reorderOrderProducts = async (orderId, items = []) => {
    const response = await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/products/reorder`,
        { items },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const createOrderCartSection = async (orderId, title, style = "light") => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/cart-sections`,
        { title, style },
        { headers: authHeaders() }
    );
    return response.data;
};

export const updateOrderCartSection = async (orderId, sectionId, title, style = "light") => {
    const response = await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/cart-sections/${sectionId}`,
        { title, style },
        { headers: authHeaders() }
    );
    return response.data;
};

export const deleteOrderCartSection = async (orderId, sectionId) => {
    const response = await axios.delete(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/cart-sections/${sectionId}`,
        { headers: authHeaders() }
    );
    return response.data;
};

export const reorderOrderCartLayout = async (orderId, items = []) => {
    const response = await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/cart-layout/reorder`,
        { items },
        { headers: authHeaders() }
    );
    return response.data;
};

export const fetchProjectEmailAddressByOrder = async (orderId, instanceUniqueId) => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/project-email/by-order/${orderId}`,
            {
                params: instanceUniqueId ? { instanceUniqueId } : undefined,
                headers: {
                    accessToken: localStorage.getItem('accessToken')
                }
            }
        );
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};


export const regeneratePresentationFromCart = async (orderId, presentationId = null, options = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/regenerate-presentation-from-cart`,
        {
            ...(presentationId ? { presentationId } : {}),
            ...options,
        },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const regenerateEstimateFromCart = async (orderId, estimationId = null, options = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/regenerate-estimate-from-cart`,
        {
            ...(estimationId ? { estimationId } : {}),
            ...options,
        },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const regenerateSalesOrderFromCart = async (orderId, estimationId = null, options = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/regenerate-sales-order-from-cart`,
        {
            ...(estimationId ? { estimationId } : {}),
            ...options,
        },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const resetSalesOrderApproval = async (orderId, estimationId, payload = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/sales-orders/${estimationId}/reset-approval`,
        payload,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const resetArtworkProofing = async (orderId, estimationId, payload = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/sales-orders/${estimationId}/reset-artwork-proofing`,
        payload,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const fetchCartHistory = async (orderId) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/cart-history`,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const fetchDocumentSnapshots = async (orderId, documentType, documentId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/document-snapshots/${documentType}/${documentId}`,
    {
      headers: {
        accessToken: localStorage.getItem('accessToken'),
      },
    }
  );

  return response.data;
};

export const fetchCartSnapshots = async (orderId) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/cart-snapshots`,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const createInvoicingCartFromSalesOrder = async (orderId, options = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/create-invoicing-cart-from-sales-order`,
        { initializeIfMissing: options?.initializeIfMissing === true },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const fetchInvoicingCart = async (orderId, invoicingCartKey = null) => {
    const params = invoicingCartKey ? { invoicingCartKey } : {};
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoicing-cart`,
        {
            params,
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const saveInvoicingCart = async (orderId, payload = [], invoicingCartKey = null) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoicing-cart`,
        { payload, ...(invoicingCartKey ? { invoicingCartKey } : {}) },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const resolveInvoiceInvoicingCart = async (orderId, invoiceId, invoicingCartKey = null) => {
    const params = invoicingCartKey ? { invoicingCartKey } : {};
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoices/${invoiceId}/invoicing-cart`,
        { params, headers: { accessToken: localStorage.getItem('accessToken') } }
    );
    return response.data;
};

export const fetchInvoicingCartDiff = async (orderId, invoicingCartKey) => {
    if (!invoicingCartKey) throw new Error('Select an invoice before comparing its Invoicing Cart.');
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoicing-cart/diff`,
        {
            params: { invoicingCartKey },
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const fetchInvoicingCartDiffByKey = async (orderId, invoicingCartKey) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoicing-carts/${invoicingCartKey}/diff`,
        { headers: { accessToken: localStorage.getItem('accessToken') } }
    );
    return response.data;
};

export const listInvoicingCarts = async (orderId) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoicing-carts`,
        { headers: { accessToken: localStorage.getItem('accessToken') } }
    );
    return response.data;
};

export const fetchInvoicingCartByKey = async (orderId, invoicingCartKey) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoicing-carts/${invoicingCartKey}`,
        { headers: { accessToken: localStorage.getItem('accessToken') } }
    );
    return response.data;
};

export const saveInvoicingCartByKey = async (orderId, invoicingCartKey, payload = [], options = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoicing-carts/${invoicingCartKey}`,
        {
            payload,
            ...(options.expectedRevisionNumber != null
                ? { expectedRevisionNumber: options.expectedRevisionNumber }
                : {}),
        },
        { headers: { accessToken: localStorage.getItem('accessToken') } }
    );
    return response.data;
};

export const createInvoicingCart = async (orderId, payload = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/invoicing-carts`,
        payload,
        { headers: { accessToken: localStorage.getItem('accessToken') } }
    );
    return response.data;
};

export const preflightBinatedProofForOrder = async (orderId, payload = null) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/preflight`,
        { payload: payload || {} },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const initiateBinatedProofForOrder = async (orderId, payload = null, context = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/initiate-proof`,
        {
            ...(payload ? { payload } : {}),
            ...context,
        },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const initiateProofWorkRequestForOrder = async (orderId, payload = null, context = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/initiate-proof`,
        {
            ...(payload ? { payload } : {}),
            ...context,
        },
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const getBinatedLifecycleByDocument = async (orderId, { documentType, documentId, requestType } = {}) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/lifecycle`,
        {
            params: {
                documentType,
                documentId,
                ...(requestType ? { requestType } : {}),
            },
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const getRequestArtStatusesByDocument = async (
    orderId,
    { documentType, documentId, requestType = "artwork-proof", fulfillmentProvider } = {}
) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/request-art-status`,
        {
            params: {
                documentType,
                documentId,
                requestType,
                ...(fulfillmentProvider ? { fulfillmentProvider } : {}),
            },
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const refreshBinatedLifecycleByDocument = async (orderId, payload = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/lifecycle/refresh`,
        payload,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const requestBinatedLifecycleRevisionByDocument = async (orderId, payload = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/lifecycle/revision`,
        payload,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const patchBinatedLifecycleStatusItemDecoration = async (requestId, placementUuid, payload = {}) => {
    const response = await axios.patch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/binated/lifecycle/${requestId}/status-items/${encodeURIComponent(String(placementUuid || ""))}/decoration`,
        payload,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const getBinatedCurrentOrderByDocument = async (orderId, { documentType, documentId, requestType, requestId } = {}) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/current-order`,
        {
            params: {
                ...(documentType ? { documentType } : {}),
                ...(documentId ? { documentId } : {}),
                ...(requestType ? { requestType } : {}),
                ...(requestId ? { requestId } : {}),
            },
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const deleteBinatedCurrentOrderByDocument = async (orderId, payload = {}) => {
    const response = await axios.delete(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/binated/current-order`,
        {
            data: payload,
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const fetchBinatedRequestFiles = async (requestId) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/binated/requests/${requestId}/files`,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const reprocessBinatedRequestFiles = async (requestId) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/binated/requests/${requestId}/reprocess-files`,
        {},
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const fetchBinatedArtworkProofMapping = async (orderId, params = {}) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/binated/orders/${orderId}/artwork-proof-mapping`,
        {
            params,
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const saveBinatedArtworkProofMappings = async (orderId, payload = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/binated/orders/${orderId}/artwork-proof-mapping`,
        payload,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const updateBinatedArtworkProofMapping = async (mappingId, payload = {}) => {
    const response = await axios.patch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/binated/artwork-proof-mappings/${mappingId}`,
        payload,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const deleteBinatedArtworkProofMapping = async (mappingId) => {
    const response = await axios.delete(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/binated/artwork-proof-mappings/${mappingId}`,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const replaceBinatedArtworkProofMappingWithFile = async (mappingId, payload = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/binated/artwork-proof-mappings/${mappingId}/replace-with-file`,
        payload,
        {
            headers: {
                accessToken: localStorage.getItem('accessToken')
            }
        }
    );
    return response.data;
};

export const fetchDocumentArtworkProofs = async (documentType, documentId, params = {}) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/proofs/documents/${documentType}/${documentId}/artwork-proofs`,
        {
            params,
            headers: authHeaders(),
        }
    );
    return response.data;
};

export const fetchDesignRepArtworkProofMapping = async (documentType, documentId, params = {}) => {
    const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/proofs/documents/${documentType}/${documentId}/artwork-proof-mapping`,
        {
            params: {
                ...params,
                ...(params?.sourceType ? { sourceType: params.sourceType } : {}),
            },
            headers: authHeaders(),
        }
    );
    return response.data;
};

export const saveDesignRepArtworkProofMappings = async (documentType, documentId, payload = {}) => {
    const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/proofs/documents/${documentType}/${documentId}/artwork-proof-mapping`,
        payload,
        {
            headers: authHeaders(),
        }
    );
    return response.data;
};

export const updateDesignRepArtworkProofMapping = async (mappingId, payload = {}) => {
    const response = await axios.patch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/proofs/artwork-proof-mappings/${mappingId}`,
        payload,
        {
            headers: authHeaders(),
        }
    );
    return response.data;
};

export const patchArtworkProofMappingClientApproval = async (mappingId, proofId, payload = {}) => {
    const response = await axios.patch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/proofs/artwork-proof-mappings/${mappingId}/proofs/${proofId}/client-approval`,
        payload,
        {
            headers: authHeaders(),
        }
    );
    return response.data;
};

export const patchArtworkProofPackageClientApproval = async (approvalGroupId, payload = {}) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/proofs/artwork-proof-packages/${approvalGroupId}/client-approval`,
    payload,
        {
            headers: authHeaders(),
        }
  );
  return response.data;
};

export const fetchDepositCheckRequests = async (orderId, instanceUniqueId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/deposit-check-requests`,
    {
      params: { instanceUniqueId },
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const createDepositCheckRequest = async (orderId, payload = {}) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/deposit-check-requests`,
    payload,
    {
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const resolveDepositCheckRequest = async (orderId, requestId, payload = {}) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/deposit-check-requests/${requestId}/resolve`,
    payload,
    {
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const cancelDepositCheckRequest = async (orderId, requestId, payload = {}) => {
  const response = await axios.post(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/deposit-check-requests/${requestId}/cancel`,
    payload,
    {
      headers: authHeaders(),
    }
  );
  return response.data;
};

export const fetchPendingDepositCheckRequests = async (instanceUniqueId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/deposit-check-requests/pending`,
    {
      params: { instanceUniqueId },
      headers: authHeaders(),
    }
  );
  return response.data;
};
